import React from "react";
import InputField from "@ingka/input-field";
import FormField from "@ingka/form-field";

interface OptionProps {
  campaignName: string,
  campaignNameValidFlag: boolean
  handleCampaignNameChange: (e: React.ChangeEvent<HTMLInputElement>) => void,
}

export const CampaignNameInput: React.FC<OptionProps> = ({
  campaignName,
  campaignNameValidFlag,
  handleCampaignNameChange
}) => {
  return (
    <div>
        <FormField
          characterLimit={20}
          valid={campaignNameValidFlag}
          shouldValidate={true}
          validation={{
            id: 'campaign name',
            msg: 'Name must start with letter and contain no special characters',
            type: 'error'
          }}
        >
          <InputField
            className="input-field"
            id="campaign-id"
            label="Campaign Name *"
            type="text"
            onChange={e => handleCampaignNameChange(e)}
            value={campaignName}
          />
        </FormField>
    </div>
  )
}